import { VendorRebateCategoryTiersGrowths } from '../../../components/Vendor/RebateCategories';

export function RebateCategoryTiersAndGrowths() {
  return <VendorRebateCategoryTiersGrowths />;
}
